export enum AsyncOperations {
  getAll = 'getAll',
  getDocumentStatusesCount = 'getDocumentStatusesCount',
  getSubmission = 'getSubmission'
}
